<template>
  <div class="search-component">
    <a-input-group>
      <a-row :gutter="8">
        <a-col :span="8">
          <a-input :id="'postal_code_input_property'"
                   @keydown.space.prevent
                   placeholder="Postcode"
                   ref="firstInputField"
                   v-model="postalCodeValue"
                   v-on:keypress="isNumberOrLetter($event)"
                   v-on:keyup.enter="onPropertySearch"/>
        </a-col>
        <a-col :span="4">
          <a-input :id="'house_number_input_property'"
                   placeholder="Huisnummer"
                   type="number"
                   v-model="houseNumberValue"
                   v-on:keypress="isNumber($event)"/>
        </a-col>
        <a-col :span="4">
          <a-input :id="'house_number_letter_input_property'"
                   placeholder="Letter"
                   v-model="houseNumberLetterValue"
                   v-on:keypress="isLetter($event)"/>
        </a-col>
        <a-col :span="4">
          <a-input :id="'house_number_addition_input_property'"
                   placeholder="Toevoeging"
                   v-model="houseNumberAdditionValue"
                   v-on:keypress="isNumberOrLetter($event)"/>
        </a-col>
        <a-col :span="3">
          <a-button :block="true"
                    id="search_property_button"
                    type="primary"
                    v-bind:loading="loading"
                    v-on:click="onPropertySearch">
            <a-icon type="search"/>
          </a-button>
        </a-col>
        <number-format-information-component/>
      </a-row>
    </a-input-group>
  </div>
</template>

<script>
import propertyApi from "~/api/property"
import NumberFormatInformationComponent from "./NumberFormatInfoComponent";

export default {
  name: "PropertySearchByAddressComponent",
  components: {NumberFormatInformationComponent},
  props: {
    property: {
      type: Object,
      required: false,
      default: null
    },
    include: {
      type: Array,
      required: false,
      default: () => []
    },
    postalCode: {
      type: String,
      required: false,
      default: null
    },
    houseNumber: {
      type: String,
      required: false,
      default: null
    },
    houseNumberAddition: {
      type: String,
      required: false,
      default: null
    },
    houseNumberLetter: {
      type: String,
      required: false,
      default: null
    },
    addressType: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      showResults: false,
      searchResults: [],
      propertyValue: this.property,
      postalCodeValue: this.postalCode,
      houseNumberValue: this.houseNumber,
      houseNumberLetterValue: this.houseNumberLetter,
      houseNumberAdditionValue: this.houseNumberAddition
    };
  },
  mounted() {
    if (this.property !== null) {
      this.postalCodeValue = this.property.postal_code;
      this.houseNumberValue = this.property.number;
      this.houseNumberAdditionValue = this.property.number_addition;
      this.propertyValue = this.property;
    }

    this.$nextTick(() => {
      this.$refs.firstInputField.$el.focus();
    });
  },
  computed: {},
  methods: {
    onPropertySearch() {
      this.loading = true;

      propertyApi.findByPostalCodeNumberNumberLetterAndNumberAddition(this.postalCodeValue, this.houseNumberValue, this.houseNumberLetterValue, this.houseNumberAdditionValue, this.include).then(response => {
        this.propertyValue = response.data;
        this.$emit('property-selected', this.propertyValue);
      }).catch(error => {
        this.$emit('no-property-found', {
          postalCode: this.postalCodeValue,
          houseNumber: this.houseNumberValue,
          houseNumberLetter: this.houseNumberLetterValue,
          houseNumberAddition: this.houseNumberAdditionValue
        })
      }).finally(() => {
        this.loading = false;
      });
    },
    isLetter(e) {
      if (e.key === 'Enter') this.onPropertySearch() // on enter initiate search
      else {
        let char = String.fromCharCode(e.keyCode);
        if (/^[a-zA-ZÀ-ÿ ß]+$/.test(char)) return true; // Match new input with regex
        else alert('Letter mag alleen letters bevatten');
        e.preventDefault(); // If no match, don't add to input
      }
    },
    isNumber(e) {
      if (e.key === 'Enter') this.onPropertySearch()// on enter initiate search
      else {
        let char = String.fromCharCode(e.keyCode);
        if (/^[0-9]+$/.test(char)) return true; // Match new input with regex
        else alert('Nummer mag alleen cijfers bevatten');
        e.preventDefault(); // If no match, don't add to input
      }
    },
    isNumberOrLetter(e) {
      if (e.key === 'Enter') this.onPropertySearch()// on enter initiate search
      else {
        let char = String.fromCharCode(e.keyCode);
        if (/^[0-9a-zA-ZÀ-ÿ ß]+$/.test(char)) return true; // Match new input with regex
        else alert('Toevoeging mag alleen cijfers en letters bevatten');
        e.preventDefault(); // If no match, don't add to input
      }
    }
  }
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
